import { render, staticRenderFns } from "./cotizaciones.vue?vue&type=template&id=16c7ec78&"
import script from "./cotizaciones.vue?vue&type=script&lang=js&"
export * from "./cotizaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports